import { Component, OnInit, Injectable, ViewChild, Inject } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { BackendService } from '../../core/backend.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';
import { Cliente } from '../cliente.model';
import { EstadoCliente } from '../estadoCliente.model';
import { AbstractComponent } from '../../core/abstract-component';
import { NavigationService } from '../../shared-services/navigation.service';
import { ISelectedChip } from '../cliente-filter.component';
import { EnvironmentProvider } from '../../core/browser-providers';
import { Environment } from '../../../environments/enviroment.model';
import { CsvmapperService } from '../../shared-services/csvmapperService';
import { ClienteExcelDto } from '../models/cliente-excel-dto.model';

enum ClienteEstadoLastLogin {
  ultimaSemana = 1,
  masUnaSemana = 2,
  masDosSemanas = 3
}

interface Filters {
  name: string;
  page: number;
  size: number;
  email: string;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-cliente-list',
  templateUrl: './cliente-list.component.html',
  styleUrls: ['./cliente-list.component.scss']
})
@Injectable()
export class ClienteListComponent extends AbstractComponent implements OnInit {

  private EstadoCliente = new EstadoCliente();
  selectedChips: ISelectedChip[] = [];
  private nameSearch = '';

  private filters: Filters = {
    name: undefined,
    email: undefined,
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  columns = [
    { name: 'username',  label: 'Nombre de usuario' },
    { name: 'nombre',  label: 'Nombre' },
    { name: 'apellidos',  label: 'Apellido' }
  ];

  public showFilters = false;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  clienteExcel =[];
  excel: ClienteExcelDto[] = [];
  subscriptions: Subscription[] = [];

  clientesList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Cliente, Cliente.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        this.clienteExcel = permissions;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Cliente[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    protected route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    protected router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    protected navigation: NavigationService,
    private csvmapperService: CsvmapperService
  ) {
    super(navigation, route, router);
  }

  ngOnInit() {

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.clientesList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refresList();
  }

  refresList() {
    this.clientesList.next(this.getFilters());
    this.showFilters = false;
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      email : undefined,
      page: 0,
      size: 50,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refresList();
  }

  async onSearch(searchText) {
    this.nameSearch = searchText;
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  async clearFilters() {
    this.searchComponent.searchBox.value = undefined;
    for (const chip of this.selectedChips) {
      chip.selectedChipFilterComponent.onRemoveChip();
    }
    this.selectedChips = [];
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  onAddCliente() {
    this.router.navigate(['/clientes/agregar']);
  }

  displayFilters() {
    this.showFilters = !this.showFilters;
  }

  async onFiltersChanged(event) {
    this.selectedChips = event;
    this.filters.search = await this.buildSearch(this.selectedChips);
    this.refresList();
  }

  buildSearch(chips: ISelectedChip[]) {
    let searchString: string;
    searchString = this.buildSearchFilter(chips.filter(x => x.categoryName === 'Última conexión'), 'ultimoLogin', true);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Último pedido'), 'ultimoPedido', true);
    searchString += this.buildSearchFilter(chips.filter(x => x.categoryName === 'Búsqueda por país'), 'paisBuscado', true);
    if (this.nameSearch) {
      searchString += 'textsearch:' + this.nameSearch + ',';
    }

    return searchString;
  }

  // El nro de documento no debe ir entre corchetes para que pueda filtrar por 'like'
  buildSearchFilter(chips: ISelectedChip[], categoryName: string, filterLike: boolean, operator: string = ':') {
    if (chips.length > 0) {
      let search = filterLike ? categoryName + operator : categoryName + operator + '[';
      let flag = false;
      for (const chip of chips) {
        if (flag) {
          search += ',';
        }
        search += chip.tagId;
        flag = true;
      }
      return filterLike ? search += ',' : search += '],';
    }
    return '';
  }

  removeChip(event) {
    this.refresList();
  }

  async descargarExcel() {
     
    await this.backendService.getExcel(Cliente.path + 'clientes-excel', this.clienteExcel).then(data => {
      this.excel = data as ClienteExcelDto[];
      this.csvmapperService.map(this.excel, "Clientes");
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-list/cliente-list.component.ts